import { render, staticRenderFns } from "./NtagLocationPage.vue?vue&type=template&id=50b01ded&scoped=true&"
import script from "./NtagLocationPage.vue?vue&type=script&lang=ts&"
export * from "./NtagLocationPage.vue?vue&type=script&lang=ts&"
import style0 from "./NtagLocationPage.vue?vue&type=style&index=0&id=50b01ded&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b01ded",
  null
  
)

export default component.exports